export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10634.9e2361e9.jpg";